import type { Sale } from "@/types";
import { adminRecognizedRevenue } from "@/utils/kpi";
import { formatCOP, formatNumber } from "@/utils/format";

const STAT_META = [
  { icon: "ri-shopping-bag-3-line", label: "Ventas del período", bubble: "bg-primary-500/25 text-primary-100" },
  { icon: "ri-hand-coin-line", label: "Utilidad estimada (25%)", bubble: "bg-accent-500/20 text-accent-200" },
  { icon: "ri-flashlight-line", label: "PV del período (stock)", bubble: "bg-secondary-500/25 text-secondary-200" },
  { icon: "ri-receipt-line", label: "Transacciones", bubble: "bg-accent-500/15 text-accent-100" },
];

// Resumen ejecutivo de ventas del período seleccionado.
// El PV ya no sale de las ventas: viene de las compras de stock del período.
const SalesStats = ({ sales, pv }: { sales: Sale[]; pv: number }) => {
  const totalSales = sales.reduce((acc, s) => acc + adminRecognizedRevenue(s), 0);

  const values = [
    formatCOP(totalSales),
    formatCOP(totalSales * 0.25),
    formatNumber(pv),
    formatNumber(sales.length),
  ];

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4">
      {STAT_META.map((meta, i) => (
        <div key={meta.label} className="glass-panel rounded-lg p-4 animate-fade-up">
          <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${meta.bubble}`}>
            <i className={`${meta.icon} text-lg`} />
          </span>
          <p className="text-[11px] text-foreground-500 mt-3">{meta.label}</p>
          <p className="text-lg md:text-xl font-heading font-extrabold text-foreground-950 mt-0.5 break-words">
            {values[i]}
          </p>
        </div>
      ))}
    </div>
  );
};

export default SalesStats;